import React, { Component } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import LoadingSpinner from "../components/LoadingSpinner";
import "../App.css";
import "../components/Datasheet-tw.css";

// defining the product variable with product details
let productData = {
  product_id: 0,
  product_name: "",
  product_type: "",
  product_sku: "",
  product_price: "",
  short_description: "",
  long_description: "",
  info_description: "",
  tech_specs: "",
  defaultImage: [],
  images: [],
  thumbnails: "",
  datasheet_benefits: "",
  datasheet_features: "",
  device_compatibility: "",
  package_content: "",
  warranty: "",
  certifications: "",
  rating: "",
  upc_code: "",
  unit_height: "",
  unit_width: "",
  unit_depth: "",
  unit_weight: "",
  height: {},
  width: {},
  depth: {},
  weight: {},
  size: "",
  shockproofLevel: "",
  waterproofLevel: "",
  compatibleModels: "",
  contact_name: "The Joy Factory",
  contact_dep: "Sales Team",
  contact_phone: "949.382.1552",
  contact_email: "sales@thejoyfactory.com",
  footer_company: "The Joy Factory Inc.",
  footer_address: "16811 Hale Ave Bldg D, Irvine, CA 92606",
  footer_email: "sales@thejoyfactory.com",
  footer_phone: "949.216.8869",
  footer_fax: "949.216.8869",
  footer_site: "www.thejoyfactory.com/",
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      loading: false,
    };
    const query = new URLSearchParams(this.props.location.search);
    this.state = {
      id: query.get("id"),
      sku: query.get("sku"),
    };
  }

  // Use Componenet state data to handle PDF Download
  createAndDownloadPdf = () => {
    axios
      .post("/create-pdf", this.state)
      .then(() => axios.get("/fetch-pdf", { responseType: "blob" }))
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: "application/pdf" });
        saveAs(pdfBlob, "datasheet-tjf.pdf");
      });
  };

  // Currently being used to handle PDF Download
  downloadPdf = () => {
    this.setState({ loading: true });
    axios
      .post("/download-tw-pdf", productData)
      .then(() => axios.get("fetch-pdf", { responseType: "blob" }))
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: "application/pdf" });
        saveAs(pdfBlob, `datasheet-${productData.product_sku}.pdf`);
        this.setState({ loading: false });
      });
  };

  fetchData = () => {
    // extract the content from the html table data
    const extractTableContent = (htmlString) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");
      const firstTable = doc.querySelector("table");
      if (!firstTable) return [];

      let tableData = [];
      firstTable.querySelectorAll("tr").forEach((row) => {
        let rowData = [];
        row.querySelectorAll("td").forEach((cell) => {
          let img = cell.querySelector("img");
          let imgSrc = img ? img.getAttribute("src") : null;
          let text = cell.textContent.trim() || null;

          // Store all values, even if image or text is null
          rowData.push({ image: imgSrc, description: text });
        });

        if (rowData.length > 0) {
          tableData.push(rowData);
        }
      });

      return tableData;
    };

    // extract description from the given htmlstring and remove table and div from it
    const extractDescription = (htmlString) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");

      // Remove all table and div elements
      doc.querySelectorAll("table, div").forEach((el) => el.remove());

      return doc.body.innerHTML;
    };

    // extract the description to get the tech specification based on the <ol></ol> tag
    const extractOL = (html) => {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      const olElement = tempDiv.querySelector("ol");

      if (!olElement) return [];

      return Array.from(olElement.children).map((li) => li.textContent.trim());
    };

    // function to get the specification from the description using given values
    const extractSpecs = (description) => {
      const sizeMatch = description.match(/尺寸：([\d\.x\s]+cm)/);
      const weightMatch = description.match(/重量：([\d\.]+\s?g)/);
      const shockproofMatch = description.match(/防震等級：(MIL-STD-\d+H)/);
      const waterproofMatch = description.match(/防水等級：(IP\d+)/);
      const compatibleMatch = description.match(/相容機型：([\w\s,\(\)A\d]+)/);

      return {
        size: sizeMatch ? sizeMatch[1] : "N/A",
        weight: weightMatch ? weightMatch[1] : "N/A",
        shockproofLevel: shockproofMatch ? shockproofMatch[1] : "N/A",
        waterproofLevel: waterproofMatch ? waterproofMatch[1] : "N/A",
        compatibleModels: compatibleMatch ? compatibleMatch[1] : "N/A",
      };
    };

    // get the thumbnail images from the list of images
    function generateThumbnails(images) {
      let thumbnails = "";

      // Ensure images is an array and not empty
      if (Array.isArray(images) && images.length > 0) {
        images.forEach((image, index) => {
          // Only add images if img320px exists and index is not 0, and is less than 4
          if (index !== 0 && index < 5 && image.src && image.src) {
            thumbnails += `<img class="thumbnail" src="${image.src}" alt="Thumbnail ${index}">`;
          }
        });
      }

      // If thumbnails were generated, add them to productData
      if (thumbnails) {
        productData.thumbnails = thumbnails;
      }
    }

    // Assign data values into state
    function handleData(data) {
      const product = data;
      productData.product_id = product.id;
      productData.product_name = product.name;
      productData.product_type = product.type;
      productData.long_description = extractDescription(product.description);
      productData.tech_specs = extractOL(product.description);
      productData.rating = product.average_rating;
      productData.datasheet_features = extractTableContent(product.description);
      productData.product_sku = product.sku;
      productData.product_price = product.price;
      productData.short_description = product.short_description;
      productData.defaultImage = product?.images[0]?.src;
      productData.images = product.images;
      generateThumbnails(product.images);
      productData.warranty = product.warranty;
      productData.depth = product.depth;
      productData.height = product.height;
      productData.weight = product.weight;
      productData.width = product.width;
      const specData = extractSpecs(product.description);
      productData.size = specData?.size;
      productData.weight = specData?.weight;
      productData.shockproofLevel = specData?.shockproofLevel;
      productData.waterproofLevel = specData?.waterproofLevel;
      productData.device_compatibility = specData?.compatibleModels;
    }

    /*
        Page rendering logic
    */
    function renderPage(data) {
      // Render the HTML for the product
      handleData(data);
      document.getElementById("product").innerHTML = renderProduct(productData);
    }

    // render product in the html datasheet preview
    function renderProduct(product) {
      // Footer - always rendered
      const footer = `
    <table class="footer text-left">
      <tr>
        <td style="width:73%;">
          <table>
            <tr>
              <td class="footer-company" style="width:73%;">The Joy Factory Inc.</td>
            </tr>
            <tr>
              <td class="footer-second-desc">
                ${product?.footer_address || ""} 
                ${
                  product?.footer_address &&
                  (product?.footer_email || product?.footer_phone)
                    ? '<span style="color: #d0103a;">|</span>'
                    : ""
                } 
                ${product?.footer_email || ""} 
                ${
                  product?.footer_email && product?.footer_phone
                    ? '<span style="color: #d0103a;">|</span>'
                    : ""
                } 
                ${product?.footer_phone ? `T : ${product.footer_phone}` : ""} 
                ${
                  product?.footer_phone && product?.footer_fax
                    ? '<span style="color: #d0103a;">|</span>'
                    : ""
                } 
                ${product?.footer_fax ? `F : ${product.footer_fax}` : ""} 
                ${
                  (product?.footer_fax || product?.footer_phone) &&
                  product?.footer_site
                    ? '<span style="color: #d0103a;">|</span>'
                    : ""
                } 
                ${product?.footer_site || ""}
              </td>
            </tr>
          </table>     
        </td>
        <td style="width:16.5%;">
          <table class="footer-icons" style="width:100%;">
            <tr>
              <td class="footer-image"><img src="https://shop.thejoyfactory.com/content/datasheet/protect.jpg" alt="The Joy Factory Protect Icon"></td>
              <td class="footer-image"><img src="https://shop.thejoyfactory.com/content/datasheet/secure.jpg" alt="The Joy Factory Secure Icon"></td>
              <td class="footer-image"><img src="https://shop.thejoyfactory.com/content/datasheet/position.jpg" alt="The Joy Factory Position Icon"></td>
            </tr>
            <tr>
              <td class="footer-image-content">Protect</td>
              <td class="footer-image-content">Secure</td>
              <td class="footer-image-content">Position</td>
            </tr>
          </table>
        </td>
        <td align="center" style="width:10.5%;">
          <img src="https://shop.thejoyfactory.com/content/datasheet/logo.png" alt="The Joy Factory logo." style="width:100px;">
        </td>
      </tr>
    </table>
  `;

      // Contact Section - only rendered if any contact info exists
      const contact =
        product?.contact_name ||
        product?.contact_dep ||
        product?.contact_phone ||
        product?.contact_email
          ? `
    <div class="contact-table" style="margin: 10px 0 300px 0; padding: 10px;">
      <table class="contact" style="background: white; width: 100%;">
        <tr>
          <td class="text-center" style="padding: 5px 30px; width: 25%;">
            <img src="https://shop.thejoyfactory.com/content/datasheet/logo-lg.png" alt="The Joy Factory logo." style="width:100px;">
          </td>
          <td class="text-left" style="padding: 5px 30px; width: 25%;">
            ${
              product?.contact_name
                ? `<p style="font-size: 1.25rem; font-weight: bold;">${product.contact_name}</p>`
                : ""
            }
            ${
              product?.contact_dep
                ? `<p style="font-size: 0.9rem; font-weight: bold;">${product.contact_dep}</p>`
                : ""
            }
          </td>
          <td class="text-left" style="border-left:solid 2px red; padding: 5px 30px; width: 50%;">
            ${
              product?.contact_phone
                ? `<p>Direct Phone Number | ${product.contact_phone}</p>`
                : ""
            }
            ${
              product?.contact_email
                ? `<p>Email Address | ${product.contact_email}</p>`
                : ""
            }
          </td>
        </tr>
      </table>
    </div>
  `
          : "";

      // Page One Content
      const pageOne = `
    <!-- Start: Page One -->
    <div class="page" id="page-one">
      <table class="text-left">
        <tr>
          <td class="product-header">
            ${
              product?.product_name
                ? `<h1 class="product-name">${product.product_name}</h1>`
                : ""
            }
            ${
              product?.short_description
                ? `<p class="product-short-desc">${product.short_description}</p>`
                : ""
            }
            ${
              product?.product_name || product?.short_description
                ? '<hr class="hr-short hr-left">'
                : ""
            }
            <div class="product-sku-price">
              ${
                product?.product_sku
                  ? `<p class="product-sku">SKU: ${product.product_sku}</p>`
                  : ""
              }
              ${
                product?.product_price
                  ? `<p class="product-price">MSRP: $${product.product_price}</p>`
                  : ""
              }
            </div>
          </td>
        </tr>
      </table>
      
      ${
        product?.long_description ||
        product?.info_description ||
        product?.defaultImage ||
        product?.thumbnails
          ? `
        <table class="product-desc-container">
          <tr>
            ${
              product?.long_description || product?.info_description
                ? `
              <td class="product-description">
                ${product?.long_description || ""}
                ${product?.info_description || ""}
              </td>
            `
                : ""
            }
            ${
              product?.defaultImage || product?.thumbnails
                ? `
              <td class="product-images">
                ${
                  product?.defaultImage
                    ? `<img class="default-image" src="${product.defaultImage}" alt="The Joy Factory product image">`
                    : ""
                }
                ${product?.thumbnails ? `<p>${product.thumbnails}</p>` : ""}
              </td>
            `
                : ""
            }
          </tr>
        </table>
      `
          : ""
      }
      
      ${
        product?.datasheet_benefits?.length > 0
          ? `
        <div class="benefits">
          <span class="benefits-header">Benefits</span>
          <br />
          <table>${product.datasheet_benefits}</table>
        </div>
      `
          : ""
      }
      
      ${
        product?.datasheet_features?.length > 0
          ? `
        <div class="features">
          <div class="features-header">Features</div>
          <br>
          <table style="width: 100%; border-collapse: collapse;">
            ${product.datasheet_features
              .map((item) => {
                const rowContent = item
                  .map((cell) => {
                    if (!cell.image && !cell.description) return "";

                    const imageSrc = cell?.image?.startsWith("http")
                      ? cell.image
                      : `https://tw.thejoyfactory.com${cell.image}`;

                    return `<td style="width: 150px; height: 70px; text-align: center; border: none;">
                      ${
                        cell.image
                          ? `<img src="${imageSrc}" style="width: 50px;">`
                          : cell.description || ""
                      }
                    </td>`;
                  })
                  .join("");

                return rowContent ? `<tr>${rowContent}</tr>` : "";
              })
              .join("")}
          </table>
        </div>
      `
          : ""
      }
      
      ${footer}
    </div>
    <!-- End: Page One -->
  `;

      // Page Two Content
      const pageTwo = `
    <!-- Start: Page Two -->
    <div class="page" id="page-two">
      <div class="tech-specs-header">
        <p>
          Technical Specifications
          <br>
          <span class="underline"></span>
        </p>
      </div>
      
      ${
        product.images?.length ||
        product?.tech_specs?.length ||
        product?.size ||
        product?.weight ||
        product?.shockproofLevel ||
        product?.waterproofLevel ||
        product?.device_compatibility
          ? `
        <table class="tech-specs-container">
          <tr>
            ${
              product.images?.length
                ? `
              <td class="tech-specs-image-container" style="padding: 0 25px;">     
                <img class="tech-spec-image" src="${
                  product.images[product.images.length - 1].src
                }" alt="The Joy Factory product image">
              </td>
            `
                : ""
            }
            ${
              product?.tech_specs?.length ||
              product?.size ||
              product?.weight ||
              product?.shockproofLevel ||
              product?.waterproofLevel ||
              product?.device_compatibility
                ? `
              <td class="tech-specs">
                ${
                  product?.size !== "N/A" ||
                  product?.weight !== "N/A" ||
                  product?.shockproofLevel !== "N/A" ||
                  product?.waterproofLevel !== "N/A" ||
                  product?.device_compatibility !== "N/A"
                    ? `
                  <p class="tech-specs-title">保護殼規格</p>
                  <ul>
                    ${
                      product?.size !== "N/A"
                        ? `<li>尺寸 : ${product.size}</li>`
                        : ""
                    }
                    ${
                      product?.weight !== "N/A"
                        ? `<li>重量 : ${product.weight}</li>`
                        : ""
                    }
                    ${
                      product?.shockproofLevel !== "N/A"
                        ? `<li>防震等級 : ${product.shockproofLevel}</li>`
                        : ""
                    }
                    ${
                      product?.waterproofLevel !== "N/A"
                        ? `<li>防水等級 : ${product.waterproofLevel}</li>`
                        : ""
                    }
                    ${
                      product?.device_compatibility !== "N/A"
                        ? `<li>相容機型 ：${product.device_compatibility}</li>`
                        : ""
                    }
                  </ul>
                  <br/>
                `
                    : ""
                }
                ${
                  product?.tech_specs?.length
                    ? `
                  <p class="tech-specs-title">技術規格</p>
                  <ul>
                    ${product.tech_specs
                      .map((item) => `<li>${item}</li>`)
                      .join("")}
                  </ul>
                `
                    : ""
                }
              </td>
            `
                : ""
            }
          </tr>
        </table>
      `
          : ""
      }
      
      ${
        product?.product_name ||
        product?.product_sku ||
        product?.product_type ||
        product?.product_price ||
        product?.device_compatibility ||
        product?.unit_height ||
        product?.unit_width ||
        product?.unit_depth ||
        product?.unit_weight ||
        product?.height?.value ||
        product?.width?.value ||
        product?.depth?.value ||
        product?.weight?.value ||
        product?.upc_code ||
        product?.warranty ||
        product?.certifications ||
        product?.rating ||
        product?.package_content
          ? `
        <div class="product-specifications">
          <table class="product-specs-table">
            <tr>
              ${
                product?.product_name ||
                product?.product_sku ||
                product?.product_type ||
                product?.product_price
                  ? `
                <td class="product-info-container">
                  ${
                    product?.product_name
                      ? `<div class="product-name text-left">${product.product_name}</div>`
                      : ""
                  }
                  <table class="product-info-inner-table">
                    <tr>
                      <div class="product-info-group">
                        ${
                          product?.product_sku
                            ? `<p>SKU: ${product.product_sku}</p>`
                            : ""
                        }
                        ${
                          product?.product_type
                            ? `<p>Product type: ${product.product_type}</p>`
                            : ""
                        }
                        ${
                          product?.product_price
                            ? `<p>MSRP: $${product.product_price}</p>`
                            : ""
                        }
                      </div>
                    </tr>
                  </table>
                </td>
              `
                  : ""
              }
              
              ${
                product?.device_compatibility ||
                product?.unit_height ||
                product?.unit_width ||
                product?.unit_depth ||
                product?.unit_weight ||
                product?.height?.value ||
                product?.width?.value ||
                product?.depth?.value ||
                product?.weight?.value ||
                product?.upc_code ||
                product?.warranty ||
                product?.certifications ||
                product?.rating ||
                product?.package_content
                  ? `
                <td class="product-specs-container">
                  <table class="product-specs-inner-table">
                    ${
                      product?.device_compatibility ||
                      product?.unit_height ||
                      product?.unit_width ||
                      product?.unit_depth ||
                      product?.unit_weight ||
                      product?.height?.value ||
                      product?.width?.value ||
                      product?.depth?.value ||
                      product?.weight?.value ||
                      product?.upc_code ||
                      product?.warranty ||
                      product?.certifications ||
                      product?.rating ||
                      product?.package_content
                        ? `
                      <th class="product-specs-title">Product Specifications</th>
                    `
                        : ""
                    }
                    ${
                      product?.device_compatibility
                        ? `<tr><td>Compatible with: ${product.device_compatibility}</td></tr>`
                        : ""
                    }
                    ${
                      product?.unit_height
                        ? `<tr><td>Product height: ${product.unit_height} in</td></tr>`
                        : ""
                    }
                    ${
                      product?.unit_width
                        ? `<tr><td>Product width: ${product.unit_width} in</td></tr>`
                        : ""
                    }
                    ${
                      product?.unit_depth
                        ? `<tr><td>Product thickness: ${product.unit_depth} in</td></tr>`
                        : ""
                    }
                    ${
                      product?.unit_weight
                        ? `<tr><td>Product weight: ${product.unit_weight} lb</td></tr>`
                        : ""
                    }
                    ${
                      product?.height?.value
                        ? `<tr><td>Package height: ${product.height.value} ${product.height.unit}</td></tr>`
                        : ""
                    }
                    ${
                      product?.width?.value
                        ? `<tr><td>Package width: ${product.width.value} ${product.width.unit}</td></tr>`
                        : ""
                    }
                    ${
                      product?.depth?.value
                        ? `<tr><td>Package depth: ${product.depth.value} ${product.depth.unit}</td></tr>`
                        : ""
                    }
                    ${
                      product?.weight?.value
                        ? `<tr><td>Package weight: ${product.weight.value} ${product.weight.unit}</td></tr>`
                        : ""
                    }
                    ${
                      product?.upc_code
                        ? `<tr><td>UPC: ${product.upc_code}</td></tr>`
                        : ""
                    }
                    ${
                      product?.warranty
                        ? `<tr><td>Warranty: ${product.warranty}</td></tr>`
                        : ""
                    }
                    ${
                      product?.certifications
                        ? `<tr><td>Certifications: ${product.certifications}</td></tr>`
                        : ""
                    }
                    ${
                      product?.rating
                        ? `<tr><td>Rating: ${product.rating}</td></tr>`
                        : ""
                    }
                    ${
                      product?.package_content
                        ? `<tr><td>Package content: ${product.package_content}</td></tr>`
                        : ""
                    }
                  </table>
                </td>
              `
                  : ""
              }
            </tr>
          </table>
        </div>
      `
          : ""
      }
      
      ${footer}
    </div>
    <!-- End: Page Two -->
  `;

      // Combine all sections
      return `
    ${pageOne}
    ${pageTwo}
    
  `;
    }

    // Check for required parameters, throw an error if they're not found
    if (!this.state) {
      throw new Error(
        "At least one of the required URL parameters (Store URL, Token) was not supplied or was invalid"
      );
    } else {
      // It seems like the required parameters were supplied, try to load the product data from the Storefront API

      axios
        .get(`/get-wp-product?id=${this.state.id}&sku=${this.state.sku}`)
        .then((data) => {
          // With our data loaded, render the product listing
          renderPage(data.data);
        })
        .catch((e) => {
          // Some error was encountered
          throw e;
        });
    }
  };

  // fetch the data on page reload
  componentDidMount = () => {
    this.fetchData();
  };

  // render the chinese datasheet preview
  render() {
    const loading = this.state.loading;

    return (
      <div className="App container my-5">
        <div className="LoadingSpinner-wrapper">
          <img
            className="download-icon"
            src="https://shop.thejoyfactory.com/content/datasheet/icons/data-sheet-icon-01.png"
            alt="icon"
          />
          <button className="btn btn-primary" onClick={this.downloadPdf}>
            Download PDF
          </button>
          {loading ? <LoadingSpinner /> : ""}
        </div>
        <div className="py-5" id="intro">
          <h1>Datasheet Preview</h1>
        </div>
        <div id="product"></div>
      </div>
    );
  }
}

export default App;
